import React from 'react';
import '../styles/PrintReceipt.css';

const PrintReceiptLayout = ({ printReceiptData: data }) => {
    if (!data) return null;

    return (
        <div id="print-section" style={{ display: 'none' }}>
            <div className="receipt-container">
                <div className="text-center">
                    {data?.restaurantLogo ? (
                        <img
                            src={data.restaurantLogo}
                            alt={data.restaurantName}
                            className="mx-auto h-16 w-auto"
                        />
                    ) : (
                        <h2>{data?.restaurantName || 'Restaurant Name'}</h2>
                    )}
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                    <p className="mb-0">{data.tableName}</p>
                    <p className="mb-0">{data.createdAt}</p>
                </div>
                <div className="d-flex justify-content-between">
                    <p className="mb-0">{data.createdBy}</p>
                    <p className="mb-0">{data.id}</p>
                </div>
                <hr />
                <table className="w-100">
                    <thead>
                        <tr>
                            <th>#Items</th>
                            <th className='text-end'>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.products?.map((item, i) => (
                            <React.Fragment key={i}>
                                <tr>
                                    <td><span style={{ paddingRight: '8px' }}>{item.quantity}</span>    {item.name}</td>
                                    <td className='text-end'>{item.productTotalPrice}</td>
                                </tr>
                                {item.modifiers?.map((m, j) => (
                                    <tr key={j}>
                                        <td style={{ paddingLeft: '40px' }}>- {m.name}</td>
                                        <td></td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>

                </table>
                <hr />
                <div className="d-flex justify-content-between">
                    <p className="mb-0">Sub total</p>
                    <p className="mb-0">{data.sub_total}</p>
                </div>
                <div className="d-flex justify-content-between">
                    <p className="mb-0">Discount</p>
                    <p className="mb-0">{data.totalDiscountAmount}</p>
                </div>
                <div className="d-flex justify-content-between">
                    <p className="mb-0">Total</p>
                    <p className="mb-0">{data.total}</p>
                </div>
                <hr />
                <table className="w-100">
                    <tbody>
                        {data.splitBillMethods?.map((payment, i) => (
                            <tr key={i}>
                                <td>{payment.payment_method_name}</td>
                                <td className='text-end'>{payment.amount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <hr />
                <table className="w-100">
                    <thead>
                        <tr>
                            <th></th>
                            <th className='text-end'>Net</th>
                            <th className='text-end'>VAT</th>
                            <th className='text-end'>Total</th>

                        </tr>
                    </thead>
                    <tbody>
                        {data.vatByCategory?.map((vat, i) => (
                            <tr key={i}>
                                <td>{!vat.categoryId ? 'VAT Total' : vat.taxRate}</td>
                                <td className='text-end'>{vat.netAmount}</td>
                                <td className='text-end'>{vat.vatAmount}</td>
                                <td className='text-end'>{vat.grossAmount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <hr />
                <div className='footer'>
                    <p className='footer-title'>Thank you, Hope to see you again</p>
                    <p className='text-center'>This is a primary bill</p>
                    <p className='text-center'>BCRSR22-1695716963</p>
                    <p className='text-center'>{data.restaurantAddress}</p>
                </div>
            </div>
        </div>
    );
};

export default PrintReceiptLayout;
